import React from "react";
import HeroSections from "./HeroSections";
// import HeroSection from "./HeroSection";
import Header from "./Header";
import NearbyPlaces from "./NearbyPlaces";

import VideoHero from "./VideoHero";
import SiteLayoutCarousel from "./SiteLayoutCarousel";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageGrid from "./ImageGrid";
import PhotoGallery from "./PhotoGallery";
import Testimonials from "./Testimonials";
import CompanyLogos from "./CompanyLogos";
import HeroVideoSection from "./HeroVideoSection";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import AboutSection from "./AboutSection";
import DiscoverRooms from "./DiscoverRooms";
import FloorplanSection from "./FloorplanSection";

AOS.init({
  duration: 500,
  once: true,
});

function Home() {
  return (
    <>
      <Header />

      <HeroSections />
      <AboutSection />
      <NearbyPlaces />
      <FloorplanSection/>
      <DiscoverRooms/>
      <Testimonials />
      <Footer />

 

      {/* <VideoHero /> */}

      {/* <ImageGrid /> */}
     
     
      {/* <PhotoGallery /> */}

      {/* <CompanyLogos /> */}
      {/* <HeroVideoSection /> */}
      {/* <FAQSection /> */}
    </>
  );
}

export default Home;
